export const onClientEntry = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevents the default mini-infobar or install prompt from showing
    e.preventDefault();
    return false;
  });
};

// Respect hash anchors: when navigating to a URL with a #hash,
// scroll to that element instead of letting Gatsby scroll to top.
export const shouldUpdateScroll = ({
  routerProps: { location },
}: {
  routerProps: { location: { hash: string } };
}) => {
  if (location.hash) {
    // Wait for the page to finish rendering before scrolling to the anchor
    const id = location.hash.slice(1);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
    return false; // tell Gatsby not to scroll
  }
  return true; // default scroll-to-top for non-hash navigations
};
